import { useState } from 'react';
import { addSavedMatch, getSavedMatches, removeSavedMatch } from '@/dom/historyStorage';
import type { ComparisonResult } from '@/types/domain';
import type { ComparisonSource, SavedMatch } from '@/types/history';

export function useSavedMatches() {
  const [savedMatches, setSavedMatches] = useState<SavedMatch[]>(() => getSavedMatches());

  function save(source: ComparisonSource, result: ComparisonResult) {
    const match: SavedMatch = { ...source, id: crypto.randomUUID(), createdAt: new Date().toISOString(), result };
    setSavedMatches(addSavedMatch(match));
  }

  function remove(id: string) {
    setSavedMatches(removeSavedMatch(id));
  }

  function isSaved(targetBrandSlug: string, sourceDescription: string): boolean {
    return savedMatches.some((m) => m.result.targetBrandSlug === targetBrandSlug && m.sourceDescription === sourceDescription);
  }

  return { savedMatches, save, remove, isSaved };
}
